import { createActionsHook } from "react-redux-actions-hook";
import { AppActionType } from "components/app/constants";

export const removeToastMessage = () => (dispatch) => {
  dispatch({
    type: AppActionType.REMOVE_TOAST_MESSAGE,
    payload: { message: "", type: "" },
  });
};

export const setToastMessage =
  ({ message, type }) =>
  (dispatch) => {
    dispatch({
      type: AppActionType.SET_TOAST_MESSAGE,
      payload: { message, type },
    });
  };

export const setBusy =
  ({ busy }) =>
  (dispatch) => {
    dispatch({
      type: AppActionType.APP_BUSY,
      payload: { busy },
    });
  };

export const setDrawerState = () => (dispatch) => {
  dispatch({
    type: AppActionType.SET_DRAWER_STATE,
  });
};
export default createActionsHook({
  removeToastMessage,
  setToastMessage,
  setDrawerState,
});
